import styled from "@emotion/styled";
import { RequiredThemeKeys } from "@smartsheet/sds-theme-internal";
import { Badge, BadgeProps } from "../../../shared/Badge";

interface AvatarBadgeProps extends BadgeProps {
    themeMode: RequiredThemeKeys;
}

export const AvatarBadge = styled(Badge)<AvatarBadgeProps>`
    ${({ size }) => `
    bottom: -5px;
    right: -5px;
    border-radius: 100%;
    padding: 0px;
    border-width: 2px;
    span:has(svg) {
        width: ${size}px;
        height: ${size}px;
    }
    ${
        size === 18
            ? `
        bottom: -7px;
        right: -7px;
    `
            : ``
    }
    `}
`;
